var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quantity quantity-default", attrs: { size: "" } },
    [
      _c(
        "Inputs",
        {
          staticClass: "choose-item",
          attrs: {
            readonly: _vm.readonly,
            size: _vm.size,
            disabled: _vm.disabled
          },
          on: { "on-blur": _vm.handleBlur, "on-focus": _vm.handleFocus },
          model: {
            value: _vm.currentValue,
            callback: function($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue"
          }
        },
        [
          !_vm.prepend
            ? _c(
                "div",
                {
                  staticClass: "am-link am-no-select",
                  attrs: { slot: "prepend" },
                  on: {
                    click: function($event) {
                      _vm.disabled || --_vm.currentValue
                    }
                  },
                  slot: "prepend"
                },
                [_vm._v("\n      -\n    ")]
              )
            : _vm._e(),
          !_vm.append
            ? _c(
                "div",
                {
                  staticClass: "am-link am-no-select",
                  attrs: { slot: "append" },
                  on: {
                    click: function($event) {
                      _vm.disabled || ++_vm.currentValue
                    }
                  },
                  slot: "append"
                },
                [_vm._v("\n      +\n    ")]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-639262b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639262b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/InputQuantity/InputQuantity.vue
// module id = iN5F
// module chunks = 0